<pdq-tabs-group variant="underline" (onChange)="onTabChange($event)" [leftMargin]="'none'">
  <pdq-tab [label]="settingsLabel" value="settings" [active]="activeTab === 'settings'"></pdq-tab>
  <pdq-tab
    label="Display Conditions"
    value="display-conditions"
    [active]="activeTab === 'display-conditions'"></pdq-tab>
</pdq-tabs-group>

<!-- Hidden with display, never @if: re-creating the projected view rebuilds every rich-text editor inside it. -->
<section [style.display]="activeTab === 'settings' ? null : 'none'">
  <ng-content></ng-content>
</section>

<section [style.display]="activeTab === 'display-conditions' ? null : 'none'">
  @if (displayConditionsGroup; as displayConditionsForm) {
    <smart-cart-form-display-conditions [formGroup]="displayConditionsForm"></smart-cart-form-display-conditions>
  }
</section>
